import { useState, useEffect } from "react";
import { motion } from "framer-motion";
export default function SectionRegister() {
  const words = [
    "Elevate",
    "Empower",
    "Ignite" 
  ];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(false);
      setTimeout(() => {
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
        setIsAnimating(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const fadeInAnimationVariants = {
    initial: { opacity: 0, y: 50 },
    animate: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.05 * index },
    }),
  };
  return (
    <div>
      <motion.div
        variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
        className="hidden xl:block mt-[50px] md:mt-[90px] w-full justify-center px-4 relative"
      >
        <div className="relative text-center flex flex-col items-center">
          {/* Arc and Static Line */}
          <div className="relative flex items-center justify-center">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/arc.png'
              className="w-[60px] h-[45px] absolute -top-[21px] left-[12px] 
                  md:w-[85px] md:h-[65px] md:-top-[40px] md:left-[-40px]"
              alt="arc"
            />
            <div
              className="text-[32px] md:text-[43px]  text-black font-bold tracking-wider"
              style={{ fontFamily: "Montserrat" }}
            >
              Level up with assessments that&nbsp;
              <span
                className="inline-block relative"
                style={{
                  display: "inline-block",
                  width: "180px", // Adjust width to fit longest word
                  height: "1em",
                }}
              >
                <span
                  className="absolute top-[-6px] w-full left-0 "
                  style={{
                    color: "#2563eb", // Tailwind's blue-600
                    fontFamily: "Montserrat",
                    transition: "opacity 0.5s, transform 0.5s",
                    opacity: isAnimating ? 1 : 0,
                    transform: isAnimating
                      ? "translateY(0)"
                      : "translateY(-10px)",
                  }}
                >
                  {words[currentWordIndex]}
                </span>
              </span>
            </div>
          </div>

          {/* Arrow */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/arrow.png'
            alt="arrow"
            className="hidden md:block w-[130px] h-[70px] absolute -top-[46px] left-[70%] -translate-x-1/2 z-10"
          />
        </div>
      </motion.div>
      <motion.div
        variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
        className="xl:hidden relative w-full pt-12 md:pt-[80px] px-4 text-center"
      >
        {/* Arc image - fixed positions per breakpoint */}
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/arc.png'
          alt="Decoration"
          className="absolute left-[2%] md:left-[7%]  transform -translate-y-1/2
                         w-[40px] h-[40px] top-[30%]
                               sm:w-[60px] sm:h-[60px] sm:top-[30%]
                             md:w-[80px] md:h-[80px] 
                              lg:w-[100px] lg:h-[100px] 
                               lg:top-[36%]"
        />

        {/* Main text content */}
        <motion.div
          variants={fadeInAnimationVariants}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          className="font-bold leading-snug"
          style={{ fontFamily: "Montserrat" }}
        >
          <div
            className="
                       text-xl
                        sm:text-[28px]
                         md:text-4xl
                                lg:text-5xl"
            style={{ fontFamily: "Montserrat" }}
          >
            Level up with Assessments that
          </div>
          <div
            className="text-blue-600 font-bold mt-3  text-xl
                          sm:text-3xl
                            md:text-5xl
                                   sm:mt-5"
            style={{
              color: "#2563eb",
              fontFamily: "Montserrat",
              transition: "opacity 0.5s, transform 0.5s",
              opacity: isAnimating ? 1 : 0,
              transform: isAnimating ? "translateY(0)" : "translateY(-10px)",
            }}
          >
            {words[currentWordIndex]}
          </div>
        </motion.div>

        {/* Arrow - fixed positions per breakpoint */}
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/arrow2.png'
          alt="Arrow"
          className="absolute left-[78%] transform -translate-y-1/2 top-[120px]
                                w-12 h-12 xs:top-[90px] 
                                 sm:w-20 sm:h-20 sm:top-[100px]
                               md:w-[100px] md:h-[100px] md:top-[140px] lg:left-[78%]"
        />
      </motion.div>

      {/* Rest of your component remains the same */}
      <motion.div
        variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
        className="flex justify-center py-6 lg:py-0 md:pb-4 bg-slate-200 md:bg-white mt-[50px]"
      >
        <div
          className="text-[32px] md:text-[43px] text-black font-bold relative px-4 text-center"
          style={{ fontFamily: "Montserrat" }}
        >
          Getting Started with Your{" "}
          <span
            className="text-orange-500"
            style={{ fontFamily: "Montserrat" }}
          >
            Journey
          </span>
        </div>
      </motion.div>

      <div className="flex flex-col md:flex-row items-center justify-center px-6 md:px-20 mt-10 bg-white overflow-x-hidden">
        {/* Left Text Content */}
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="max-w-2xl md:mr-20"
        >
          <div
            className="text-2xl md:text-3xl font-bold text-black mb-4 text-center"
            style={{ fontFamily: "Montserrat" }}
          >
            Step 1: Register / Log In Your Account
          </div>
          <p
            className="text-blue-600 text-lg mb-6 text-center md:text-left"
            style={{ fontFamily: "Poppins" }}
          >
            Fill in a few quick details to set up your personal account.
          </p>

          <ul className="space-y-4 text-base text-black">
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                1
              </span>
              Choose your role (Student/Parent).
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                2
              </span>
              Add email, password, and student information.
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                3
              </span>
              You'll receive login details on your registered email.
            </li>
          </ul>

          <p className="mt-6 text-md text-black font-medium tracking-wide text-center md:text-left">
            <span role="img" aria-label="email">
              📩
            </span>{" "}
            <strong className="" style={{ fontFamily: "Poppins" }}>
              Please mention valid mail id as updates will be shared.
            </strong>
          </p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="relative md:mt-0 md:ml-10"
        >
          <div className="absolute inset-0 w-full h-full rounded-xl bg-[radial-gradient(circle_at_center,_#87CEEB,_transparent_60%)] z-0"></div>
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/registerimg.png'
            alt="Register Illustration"
            className="relative w-full max-w-md z-10"
          />
        </motion.div>
      </div>

      <div className="hidden md:flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-12 bg-white relative overflow-x-hidden">
        {/* Images - now comes first on mobile (added order-1) */}
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="relative w-full md:w-1/2 mb-10 md:mb-0 flex items-center justify-center order-1 md:order-none"
        >
          {/* Glowing Background - unchanged */}
          <div className="absolute top-0 left-0 w-[90%] h-[90%] bg-[radial-gradient(circle_at_center,_#FFB6C1,_transparent_70%)] rounded-full blur-3xl opacity-80 z-0"></div>

          {/* Checklist Icon - unchanged */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/todo.png'
            alt="Checklist Icon"
            className="absolute top-0 left-[18%] w-24 md:w-28 z-20"
          />

          {/* Laptop Image - unchanged */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/Laptop%201.png'
            alt="Laptop Illustration"
            className="relative z-10 w-full max-w-md"
          />
        </motion.div>

        {/* Text - now comes second on mobile (added order-2) */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="w-full md:w-1/2 md:pl-10 order-2 md:order-none"
        >
          <div
            className="text-2xl md:text-3xl font-bold mb-6 text-center"
            style={{ fontFamily: "Montserrat" }}
          >
            Step 2: Begin and Take the Assessment
          </div>
          <ul className="space-y-4 text-base md:text-md text-gray-800">
            {/* All list items remain exactly the same */}
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                1
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Click the{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  "Start"
                </strong>{" "}
                button next to your name to begin.
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                2
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                The assessment consists of two sections:{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  Aptitude and Personality
                </strong>
                .
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                3
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Both sections are time-bound and must be done in one go.
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                4
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Answer{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  honestly
                </strong>{" "}
                for accurate evaluation.
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
      <div className="md:hidden flex flex-col md:flex-row items-center justify-between px-6 md:px-16 pt-8 bg-white relative overflow-x-hidden">
        {/* Images - now comes first on mobile (added order-1) */}

        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="w-full md:w-1/2 md:pl-10"
        >
          <div
            className="text-2xl md:text-3xl font-bold mb-6 text-center"
            style={{ fontFamily: "Montserrat" }}
          >
            Step 2: Begin and Take the Assessment
          </div>
          <ul className="space-y-4 text-base md:text-md text-gray-800">
            {/* All list items remain exactly the same */}
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                1
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Click the{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  "Start"
                </strong>{" "}
                button next to your name to begin.
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                2
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                The assessment consists of two sections:{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  Aptitude and Personality
                </strong>
                .
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                3
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Both sections are time-bound and must be done in one go.
              </span>
            </li>
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
              <span
                className="text-white bg-blue-600 rounded-full text-xs w-6 h-6 flex items-center justify-center font-semibold mr-3 flex-shrink-0"
                style={{ fontFamily: "Poppins" }}
              >
                4
              </span>
              <span style={{ fontFamily: "Poppins" }}>
                Answer{" "}
                <strong
                  style={{ fontFamily: "Poppins" }}
                  className="text-gray-600"
                >
                  honestly
                </strong>{" "}
                for accurate evaluation.
              </span>
            </li>
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          className="relative w-full md:w-1/2 mt-7 md:mb-0 flex items-center justify-center"
        >
          {/* Glowing Background - unchanged */}
          <div className="absolute top-0 left-0 w-[90%] h-[90%] bg-[radial-gradient(circle_at_center,_#FFB6C1,_transparent_70%)] rounded-full blur-3xl opacity-80 z-0"></div>

          {/* Checklist Icon - unchanged */}
          {/* <img
            src='https://dbqa318yoj3nn.cloudfront.net/todo.png'
            alt="Checklist Icon"
            className="absolute top-0 left-[1%] w-24 md:w-28 z-20"
          /> */}

          {/* Laptop Image - unchanged */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/Laptop%201.png'
            alt="Laptop Illustration"
            className="relative z-10 w-full max-w-md"
          />
        </motion.div>
      </div>
    </div>
  );
}
